import _ from 'lodash';
import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
// import autobind from 'autobind-decorator';

import Editor from 'client/shared/components/editor';

// export default ({  }) => {
export default class QuillItem extends React.Component {
	
	render() {
		const { documentStore, active = 'ARTIST_FAQ' } = this.props;
		console.log("this.state.active")
		console.log(active)
		console.log(_.filter(documentStore.testDocuments, {type: active})[0].content)
		return (
			<Fragment>
				<div className="cell small-7">
					<Editor
						content={ _.filter(documentStore.testDocuments, {type: active})[0].content }
						onChange={ this.onChange }
						onBlur={ this.onBlur }
					> </Editor>
				</div>
				<div className="cell small-5"></div>
			</Fragment>
		);
	}
};

